import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { DisplayL } from '@sorare/core/src/atoms/typography';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const Wrapper = styled(Vertical)`
  background-position: center;
  background-size: cover;
  aspect-ratio: 4;
  justify-content: flex-end;
  align-items: flex-start;
  padding: var(--double-unit) var(--double-unit) 0;

  @media ${laptopAndAbove} {
    background-position: top center;
    padding: var(--triple-unit) var(--triple-unit) 0;
  }
  &.fixed {
    max-height: 380px;
    aspect-ratio: auto;
  }
`;

const LeagueLogo = styled.img`
  height: 100px;
  width: auto;
`;

const Title = styled(DisplayL)`
  @media ${laptopAndAbove} {
    font-size: calc(12 * var(--unit));
    line-height: 1.1;
  }
`;

type Props = {
  backgroundImage: string;
  leagueLogo?: {
    src: string;
    alt: string;
  };
  title?: ReactNode;
  children?: ReactNode;
  fixed?: boolean;
};

export const Header = ({
  leagueLogo,
  backgroundImage,
  fixed,
  title,
  children,
}: Props) => {
  const { src: leagueLogoSrc, alt: leagueLogoAlt } = leagueLogo || {};
  return (
    <Wrapper
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 75%, rgb(16, 16, 16) 100%), url(${backgroundImage})`,
      }}
      className={classNames({ fixed })}
    >
      {children || (
        <>
          <LeagueLogo src={leagueLogoSrc} alt={leagueLogoAlt} />
          <Title as="h1">
            {title || (
              <FormattedMessage
                id="scoutingCenter.title"
                defaultMessage="Scouting Center"
              />
            )}
          </Title>
        </>
      )}
    </Wrapper>
  );
};
